/**
 * region for libraries*/
import React, { Component } from 'react';

/**
 * region for helpers*/
import typing from '../../helpers/typing';

/**
 * region for constans*/
import Constants from '../../constants/Constants';

export class Paginator extends Component {
    static displayName = Paginator.name;

    constructor(props) {
        super(props);
        this.state = {
            totalCount: this.props.totalCount,
            currentPage: this.props.currentPage,
        };
        
        this.setCurrentPage = this.props.handleSetCurrentPage;
    }

    handleSetCurrentPage(newCurrentPage, e) {
        this.setCurrentPage(newCurrentPage);
        e.preventDefault();
    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;

        this.setState({
            totalCount: nextProps.totalCount,
            currentPage: nextProps.currentPage,
        });
    }

    render() {

        const pageSize = this.props.pageSize || Constants.PAGE_SIZE;

        if (this.state.totalCount > pageSize) {

            let firstClass = 'page-item';

            let numberOfPages = (this.state.totalCount / pageSize);
            if (!typing.isInteger(numberOfPages)) {
                numberOfPages = Math.ceil(numberOfPages);
            }

            let startPage = 1;

            if (this.state.currentPage > 3) {
                if (this.state.currentPage - 2 > 0 && numberOfPages > this.state.currentPage + 1)
                    startPage = this.state.currentPage - 2;
                else if (numberOfPages > 4)
                    startPage = numberOfPages - 4;
            }


            let previousPage;
            if (this.state.currentPage === 1) {
                firstClass += ' active';
                previousPage = <li className='page-item disabled'><span className="page-link prev-page-link"><i className="fas fa-angle-left" /> Previous page</span></li>;
            }
            else {
                let boundClick = this.handleSetCurrentPage.bind(this, this.state.currentPage - 1);
                previousPage = <li className='page-item'><a href="#/" onClick={boundClick} className="page-link prev-page-link"><i className="fas fa-angle-left" /> Previous page</a></li>;
            }
            
            let nextPage;
            if (this.state.currentPage === numberOfPages) {
                nextPage = <li className='page-item disabled'><span className="page-link next-page-link">Next page <i className="fas fa-angle-right" /></span></li>;
            }
            else {
                let boundClick = this.handleSetCurrentPage.bind(this, this.state.currentPage + 1);
                nextPage = <li className='page-item'><a href="#/" onClick={boundClick} className="page-link next-page-link">Next page <i className="fas fa-angle-right" /></a></li>;
            }


            let boundClickFirstPage = this.handleSetCurrentPage.bind(this, 1);
            let firstPage;
            if (this.state.currentPage === 1) {
                firstPage = <li className={firstClass }><span className="page-link">1</span></li>;
            }
            else {
                firstPage = <li className={firstClass }><a href="#/" onClick={boundClickFirstPage} className="page-link">1</a></li>;
            }

            let lastPage;
            if (this.state.currentPage === numberOfPages) {
                lastPage = <li className="page-item active"><span className="page-link">{numberOfPages}</span></li>;
            } else {
                let boundClick = this.handleSetCurrentPage.bind(this, numberOfPages);
                lastPage = <li className="page-item"><a href="#/" className="page-link" onClick={boundClick}>{numberOfPages}</a></li>;
            }

            let firstEllipsis = '';
            if (this.state.currentPage > 3) {
                firstEllipsis = <li className="page-item disabled"><span className="page-link">…</span></li>;
            }

            let lastEllipsis = '';
            if (this.state.currentPage + 3 < numberOfPages) {
                lastEllipsis = <li className="page-item disabled"><span className="page-link">…</span></li>;
            }

            let pages = [];
            for (let i = startPage; i <= (numberOfPages -1) && i < (startPage + 5) ; i++) {
                if (i > 1) {
                    let pageClass = 'page-item';
                    if (i === this.state.currentPage) {
                        pageClass += ' active';
                    }
                    const boundClick = this.handleSetCurrentPage.bind(this, i);
                    pages.push(<li key={i} className={pageClass }><a href="#/" className="page-link" onClick={boundClick}>{i}</a></li>);
                }
            }

            return (
                    <nav>
                        <ul className="pagination pagination-lg justify-content-center">
                            {previousPage}
                            {firstPage}
                            {firstEllipsis}
                            {pages}
                            {lastEllipsis}
                            {lastPage}
                            {nextPage}
                        </ul>
                    </nav>

                    );
                }
        else {
            return null;
        }

    };
}

export default Paginator;